import React from 'react';
import { useDispatch } from 'react-redux';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { DefaultValueDrawerBannerType } from 'entities/banner/types';
import { useUpdateBannerCardDefaultValues } from 'entities/banner/lib/hooks';
import { useGetBannerByIdQuery, useUpdateBannerMutation } from 'entities/banner/api';
import { BannerCard } from './BannerCard';

export const UpdateBannerCard = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [updateBanner] = useUpdateBannerMutation();
  const { data: bannerDetail } = useGetBannerByIdQuery({ id });

  const updateBannerCardDefaultValues = useUpdateBannerCardDefaultValues(bannerDetail);

  const updateBannerForm = useForm<Partial<DefaultValueDrawerBannerType>>({
    defaultValues: updateBannerCardDefaultValues,
  });

  const onSubmit: SubmitHandler<Partial<DefaultValueDrawerBannerType>> = (data) => {
    updateBanner({ id, form: data }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  // @ts-ignore TODO refactor
  return (
    <BannerCard
      title="Изменить баннер"
      form={updateBannerForm}
      onSubmit={onSubmit}
    />
  );
};
